import React, { useEffect, useRef, useState } from 'react';
import { Stage, Layer, Rect } from 'react-konva';

const ZoomableStage = ({stagePropes,children,setStagePropes,onClick,onTap,onDraging }) => {
  const stageRef = useRef(null);
  const [draggable, setDraggable] = useState(true);
  const [lastScale, setLastScale] = useState(stagePropes.scaleX);
  const [lastDist, setLastDist] = useState(0);
  const [lastPos, setLastPos] = useState({ x: 0, y: 0 });

  useEffect(()=>{
    setLastScale(stagePropes.scaleX)
  },[stagePropes.scaleX])

  const handleTouchStart = (e) => {
    const touch1 = e.evt.touches[0];
    const touch2 = e.evt.touches[1];
    if (e.evt.touches.length === 2) {
      setDraggable(false)
      onDraging(true)
      setLastDist(Math.sqrt(
        Math.pow(touch2.clientX - touch1.clientX, 2) +
        Math.pow(touch2.clientY - touch1.clientY, 2)
      ))
      setLastPos({
        x: (touch1.clientX + touch2.clientX) / 2,
        y: (touch1.clientY + touch2.clientY) / 2
      });
    }
  };

  const handleTouchMove = (e) => {
    const stage = stageRef.current;
    const touch1 = e.evt.touches[0];
    const touch2 = e.evt.touches[1];
    if (e.evt.touches.length === 2 && touch1 && touch2) {
      setDraggable(false)
      onDraging(true)
      const dist = Math.sqrt(
        Math.pow(touch2.clientX - touch1.clientX, 2) +
        Math.pow(touch2.clientY - touch1.clientY, 2)
      );
      const newScale = (dist / lastDist) * lastScale;

      const pointer = {
        x:(touch1.clientX + touch2.clientX) / 2,
        y:(touch1.clientY + touch2.clientY) / 2,
      };

      setLastScale(newScale)
      setLastDist(dist)
      setLastPos(pointer)

      const oldScale = stage.scaleX();
      const mousePointTo = {
        x: (lastPos.x - stage.x()) / oldScale,
        y: (lastPos.y - stage.y()) / oldScale,
      };
      const newPos = {
        x: pointer.x - mousePointTo.x * newScale,
        y: pointer.y - mousePointTo.y * newScale,
      };
      stage.position(newPos);
      stage.scale({ x: newScale, y: newScale });                                                         
      stage.batchDraw();
      setStagePropes({...stagePropes,...newPos,scaleX:newScale,screenY:newScale})
    }
  };

  const handleTouchEnd = () => {
    setDraggable(true)
    onDraging(false)
  };

  const handleWheel = (e) => {
    e.evt.preventDefault(); // 阻止默认的滚轮事件
    const stage = stageRef.current;
    const oldScale = stage.scaleX();
    const newScale = e.evt.deltaY < 0 ? oldScale * 1.1 : oldScale / 1.1; // 根据滚轮事件调整缩放比例
    // setLastScale(Math.max(0.001, Math.min(3, newScale)));
    setLastScale(newScale);
    const pointer = stage.getPointerPosition();
    const mousePointTo = {
      x: (pointer.x - stage.x()) / oldScale,
      y: (pointer.y - stage.y()) / oldScale,
    };
    const newPos = {
      x: pointer.x - mousePointTo.x * newScale,
      y: pointer.y - mousePointTo.y * newScale,
    };
    stage.position(newPos);
    stage.scale({ x: newScale, y: newScale });
    stage.batchDraw();
    setStagePropes({...stagePropes,...newPos,scaleX:newScale,screenY:newScale})
  }
  return (
    <Stage
      ref={stageRef}
      scaleX={lastScale}
      scaleY={lastScale}
      {...stagePropes}
      draggable = {draggable}
      onWheel={handleWheel}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onDragEnd={(e)=>{
        const {x,y} = e.target.attrs
        setStagePropes({...stagePropes,x,y})
      }}
    >
      {children}
    </Stage>
  );
};

export default ZoomableStage;